import { useEffect } from "react";
import { Card, Container, Row} from "react-bootstrap";
import { startLoadCommissions } from "../../actions/commissionActions";
import CommissionsTable from "../../components/commisionComponents/commissionsTable";
import { useAppDispatch } from "../../hooks/redux-hooks";
import Dashboard from "../../layouts/Dashboard/Dashboard";
import useIsMounted from "../../hooks/useIsMounted";

const CommissionScreen = () => {
  const dispatch = useAppDispatch();
  const isMounted = useIsMounted();

  useEffect(() => {
    document.title = "Comisiones";
  }, []);

  
  useEffect(() => {
    if(isMounted()){
      dispatch(startLoadCommissions());
    }
    // eslint-disable-next-line
  }, [isMounted]);

  return (
    <Dashboard>
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <Card.Header className="border-0">
                <h3 className="mb-0">Comisiones</h3>
              </Card.Header>
              <Container>
              <CommissionsTable />
              </Container>
            </Card>
          </div>
        </Row>
      </Container>
    </Dashboard>
  );
};

export default CommissionScreen;
